import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import BaseDialog from '../Common/BaseDialog';
import { getStyles } from './styles';

interface SuccessDialogueProps {
    closeDialog: any;
    success: boolean;
    action?: 'save' | 'update';
}
export default function SuccessDialog({ closeDialog, success, action = 'save' }: SuccessDialogueProps) {
    const theme = useTheme();
    const styles = getStyles(theme);

    const successTitle = `Records Successfully ${action === 'update' ? 'Updated' : 'Saved'}!`;
    const successMessage = action === 'update' 
        ? `The adhoc record has successfully been updated. The next time a batch is synced, the roster data will be updated accordingly.`
        : `The adhoc records have successfully been added. The next time a batch is synced, the roster data will be updated accordingly.`;
    const errorTitle = `Error ${action === 'update' ? 'Updating' : 'Saving'} Records`;
    const errorMessage = `There was an error ${action === 'update' ? 'updating' : 'saving'} the records. Please try again later.`;

    const title = success ? successTitle : errorTitle;
    const message = success ? successMessage : errorMessage;

    return (
        <BaseDialog
            open={true}
            showCloseIcon={false}
            showCloseButton={false}
            onClose={closeDialog}
        >
            {<>
                <Box sx={styles.classSubmittedDialog}>
                    <Typography component='p' variant='h6' sx={styles.title}>
                        {title}
                    </Typography>
                    <Typography component='p' sx={styles.message}>
                        {message}
                    </Typography>
                    <Button
                        color='primary'
                        variant='contained'
                        onClick={closeDialog}
                        sx={styles.ok}
                    >
                        OK
                    </Button>
                </Box>
            </>
            }
        </BaseDialog>
    );
}